import { render, staticRenderFns } from "./VehicleSearch.vue?vue&type=template&id=dc5ff642"
import script from "./VehicleSearch.vue?vue&type=script&lang=js"
export * from "./VehicleSearch.vue?vue&type=script&lang=js"
import style0 from "./VehicleSearch.vue?vue&type=style&index=0&id=dc5ff642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports